"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _g;
var CloseCircle = function CloseCircle(props) {
  return /*#__PURE__*/_react.default.createElement("svg", Object.assign({
    viewBox: "0 0 13 13"
  }, props), _g || (_g = /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", {
    opacity: "{0.5}"
  }, /*#__PURE__*/_react.default.createElement("g", {
    opacity: "{-0.5}"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 20,
    d: "M6.342 11.683A5.342 5.342 0 1 0 6.342 1a5.342 5.342 0 0 0 0 10.683z"
  })), /*#__PURE__*/_react.default.createElement("g", {
    opacity: "{-0.5}"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 20,
    d: "M4.56 4.76l3.568 3.568"
  })), /*#__PURE__*/_react.default.createElement("g", {
    opacity: "{-0.5}"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 20,
    d: "M8.128 4.76L4.56 8.328"
  }))))));
};
var _default = exports.default = CloseCircle;